// import React from "react";
// import Slider from "react-slick";
// import "./CustomSlider.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const CustomSlider2 = ({slidesdata}) => {

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     // nextArrow: <CustomArrow type="next" />,
//     // prevArrow: <CustomArrow type="prev" />,
//     responsive: [
//         {
//           breakpoint: 768, 
//           settings: {
//             dots: true, 
        
//           },
//         },
//       ],
//   };


//   return (
//     <div className="plr-10">
//     <div className=" custom-slider-container-new p-2">
//       <Slider {...settings}>
//         {slidesdata.map((slide) => (
//           <div key={slide.id} >
   
        
//               <div className="ps-3 pb-3 pt-3" style={{border:'1px solid rgba(220, 220, 220, 1)',borderRadius:'20px'}}>
//               <div className="row">
//                 <div className="col-md-8 ps-lg-4">
//                     <p className="fw-800 fs-36 plus font-20" style={{color:slide.bgcolor}}>{slide.title}</p>
//                     <p className="fw-500 fs-16 plus font-14" style={{color:'rgba(0, 0, 0, 0.55)'}}>{slide.description}</p>

//                 </div>
//                 <div className="col-md-4 ">
//                     <div className="">
//                     <img src={slide.bgimage} alt="" className="img-fluid" />
//                     </div>
//                     </div>

//                     </div>
//             </div>
         
    
            
//           </div>
//         ))}
//       </Slider>
//     </div>
//     </div>
//   );
// };

// const CustomArrow = ({ type, onClick }) => {
//   return (
//     <div
//       className={`custom-arrow ${type === "next" ? "arrow-next" : "arrow-prev"}`}
//       onClick={onClick}
//     >
//       {type === "next" ? "→" : "←"}
//     </div>
//   );
// };

// export default CustomSlider2;



import React, { useRef } from "react";
import Slider from "react-slick";
import "./CustomSlider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomSlider2 = ({ slidesdata }) => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false, 
  };

  // ⏸️ **Pause on Hover**
  const handleMouseEnter = () => {
    sliderRef.current?.slickPause();
  };

  // ▶️ **Instant Resume on Mouse Leave**
  const handleMouseLeave = () => {
    sliderRef.current?.slickPlay();
  };

  return (
    <div 
      className="custom-slider-container-new p-lg-4"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} 
    >
      <Slider ref={sliderRef} {...settings}>
        {slidesdata.map((slide) => (
          <div key={slide.id} className="slide-item">  
            <div
              className="ps-3 pb-3 pt-3"
              style={{
                border: "1px solid rgba(220, 220, 220, 1)",
                borderRadius: "20px",
              }}
            >
              <div className="row h-340">
                <div className="col-md-8 ps-lg-4">
                  <p className="fw-800 fs-36 plus font-25" style={{ color: slide.bgcolor }}>
                    {slide.title}
                  </p>
                  <p className="fw-500 fs-16 plus  hideinmo " style={{ color: "rgba(0, 0, 0, 0.55)" }}>
                    {slide.description}
                  </p>
                </div>
                <div className="col-md-4">
                  <div>
                    <img src={slide.bgimage} alt="" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>

   
  

  );
};

export default CustomSlider2;
